import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Store } from "@ngrx/store";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { Subscription } from "rxjs";
import { AnnouncementReciverInterface } from "src/app/shared/interfaces";
import { announcementActions, selectAnnouncement } from "src/app/shared/store";
import { MobileHeaderComponent } from "../../ui";
import { AnnouncementDetailComponent } from "../announcement-detail/announcement-detail.component";

@Component({
    selector: "sms-announcement-details-page",
    standalone: true,
    imports: [CommonModule, AnnouncementDetailComponent, MobileHeaderComponent, ProgressSpinnerModule],
    templateUrl: "./announcement-details-page.component.html",
    styleUrls: ["./announcement-details-page.component.scss"],
})
export class AnnouncementDetailsPageComponent {
    announcement: AnnouncementReciverInterface | null;
    isMobile: boolean = false;
    subscription: Subscription = new Subscription();
    announcement_id: string;
    loading: boolean = false;

    constructor(
        private store: Store,
        private route: ActivatedRoute,
    ) {}

    ngOnInit() {
        this.store.select(selectAnnouncement).subscribe((data: any) => {
            this.announcement = data;
            this.loading = false;
        });

        this.subscription.add(
            this.route.params.subscribe((value) => {
                this.store.dispatch(announcementActions.clearState());
                if (value["id"]) {
                    this.announcement_id = value["id"];

                    this.getAnnouncementData();
                }
            }),
        );
    }

    getAnnouncementData() {
        this.loading = true;
        this.store.dispatch(announcementActions.getOneAnnouncement({ id: this.announcement_id }));
    }
}
